import { createContext } from 'react';

export const DEFAULT_TOMBSTONE = {
    fields: [
        {
            name: 'Opening time',
            field: 'openingtime',
            selected: true
        },
        {
            name: 'Type',
            field: 'type',
            selected: true
        },
        {
            name: 'Status',
            field: 'status',
            selected: true
        }
    ]
};

const IncidentContext = createContext();
export default IncidentContext;